<template>
  <div class="transfer-call">
    
    <el-radio-group class="transfer-call__tabs-container" v-model="activeTab" size="small">
      <el-radio-button v-for="type in ['agent', 'queue', 'custom']" class="transfer-call__tabs-option" :label="type" :key="type">
        {{ $t(`agent-console.transfer-call.${type}`) }}
      </el-radio-button>
    </el-radio-group>

    <div class="tab-content">
      <input type="text" :placeholder="activeTab === 'custom' ? 'Ingrese numero destino' : 'Buscar'" v-model="searchQuery" />
      <ul class="transfer-call__list" v-if="activeTab !== 'custom'">
        <li v-for="item in list" :key="item.number" @click="selectDestination(item)">
          <input type="radio" :value="item.id" v-model="value" :key="item.id" />
          <i class="fas" :class="{
            'fa-headset': activeTab === 'agent',
            'fa-robot': activeTab === 'queue',
          }"></i>
          <label :for="item.number">
            <span>{{ item.name }}</span><br>
            <span>Número: {{ item.id }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js';

export default {
  data() {
    return {
      activeTab: 'agent',
      searchQuery: '',
      selectedDestination: null,
      value: 0
    };
  },
  computed: {
    agents () {
      return this.$store.getters['getAgentsDashboard']
        .filter(agent => agent.call_logged && agent.have_call_center)
        .filter((agent) => {

          if (!this.searchQuery) {
            return agent
          }

          return agent.name.toLowerCase().includes(this.searchQuery.toLowerCase()) || agent.number.toString().includes(this.searchQuery.toLowerCase())
        }).map((agent) => ({
          id: agent.number,
          name: agent.name,
          extra: {
            inCall: agent?.call_status === 'call',
            inBreak: agent.in_break ?? false
          }
        }))
    },
    filteredAgents() {
      return this.agents.filter(agent =>
        agent.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    queues () {
      return this.$store.getters['getQueuesDashboardList']
        .filter(queue => !queue.isQueueAgent)
        .filter((queue) => {
          if (!this.searchQuery) {
            return queue
          }

          return queue.name.toLowerCase().includes(this.searchQuery.toLowerCase()) || queue.queue.toString().includes(this.searchQuery.toLowerCase())
        }).map((queue) => ({
          id: queue.queue,
          name: queue.name,
          extra: {
            agentsOnline: queue.onlineAgents,
          }
        }))
    },
    list () {
      return this.activeTab === 'agent' ? this.agents : this.queues
    }
  },
  methods: {
    selectDestination(_destination){
      this.selectedDestination = _destination;
      this.value = _destination.id;
      EventBus.$emit('select-destination-transfer', this.activeTab === 'custom' ? this.searchQuery : _destination.id)
    },
  }, 
  watch: {
    searchQuery(newValue) {
      if(!this.activeTab === 'custom') return
      EventBus.$emit('digit-destination', newValue)
    },
  },
  
};
</script>
<style>
.transfer-call__tabs-container .el-radio-button__inner{
  border: 1px solid #ccc;
  border-radius: 4px !important;
  font-size: 14px;
}
</style>
<style scoped>
h3 {
  margin-bottom: 10px;
}

.transfer-call__tabs-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  overflow-x: auto;
}

.tab-content input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.transfer-call__list {
  list-style: none;
  padding: 0;
  max-height: 115px;
  overflow-y: auto;
}

.transfer-call__list li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding: 5px;
  border: 1px solid #ccc;
}

.transfer-call__list li i {
  font-size: 20px;
  text-align: center;
  width: 20%;
  cursor: pointer;
}
.transfer-call__list li input[type="radio"] {
  width: 15px;
  margin: 0;
}
.transfer-call__list li label {
  width: 80%;
  font-size: 14px;
}

</style>